// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 1025px)";
var _4 = "title-1VWhP";
var _5 = "text-79kba";
var _6 = "row-3JOAu";
var _7 = "button_wrapper-5vH7f";
var _8 = "social_wrapper-zA25Q";
var _9 = "social_title-33QxI";
var _a = "root-3vCSS";
export { _1 as "__esModule", _2 as "mobile", _3 as "laptop", _4 as "title", _5 as "text", _6 as "row", _7 as "button_wrapper", _8 as "social_wrapper", _9 as "social_title", _a as "root" }
export default { "__esModule": _1, "mobile": _2, "laptop": _3, "title": _4, "text": _5, "row": _6, "button_wrapper": _7, "social_wrapper": _8, "social_title": _9, "root": _a }
